import { Empty } from "@bednbody/ui/components/empty";
import { Button } from "@bednbody/ui/components/button";
import { Badge } from "@bednbody/ui/components/badge";
import { SurfaceCard } from "@bednbody/ui/components/surface-card";
import { useMileageRequests, useApproveMileageRequest } from "../mileage.hooks";

export function MileageApprovalQueue() {
  const { data: pending, isLoading } = useMileageRequests("pending");
  const approve = useApproveMileageRequest();

  if (isLoading) {
    return <p className="text-sm text-muted-foreground">Loading requests…</p>;
  }

  if (!pending || pending.length === 0) {
    return <Empty>No pending rate change requests.</Empty>;
  }

  // Bracket/rate/effective date all live server-side on the stored request
  // row already (approve_mileage_rate_request, 0022 reads them itself) — the
  // approver only needs to send the decision, resolved actor comes from the
  // verified JWT, never the client.
  function handleDecision(requestId: string, approved: boolean) {
    approve.mutate({ requestId, approve: approved });
  }

  return (
    <div className="flex flex-col gap-3">
      {pending.map((req) => (
        <SurfaceCard key={req.id} className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium">
              ₱{req.fuel_price}/L → bracket {req.computed_bracket} → ₱{req.suggested_rate}/km
              {req.is_fast_track && (
                <Badge variant="warning-soft" shape="soft">
                  fast-track
                </Badge>
              )}
            </p>
            <p className="text-xs text-muted-foreground">
              Effective {req.requested_effective_date}
              {req.notes ? ` · ${req.notes}` : ""}
            </p>
          </div>
          <div className="flex gap-2">
            <Button
              variant="outline"
              size="sm"
              type="button"
              onClick={() => handleDecision(req.id, false)}
              disabled={approve.isPending}
            >
              Reject
            </Button>
            <Button
              variant="default"
              size="sm"
              type="button"
              onClick={() => handleDecision(req.id, true)}
              disabled={approve.isPending}
            >
              Approve
            </Button>
          </div>
        </SurfaceCard>
      ))}
    </div>
  );
}
